module.exports = "<!-- Loads either the layout.component.ts or pages/auth.routing.ts -->\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/route-handler/route-handler.component.html
// module id = ../../../../../src/app/core/route-handler/route-handler.component.html
// module chunks = main